import React from "react";
import classes from "./blogsListPage.module.css";
import { BlogsFilterPage } from "./blogsFilter/BlogsFilterPage";
import { useSelector } from "react-redux";
import { selectBlogFilter } from "../../store/blog/blogFilterSlice";
import {
  selectAllBlogs,
  useGetBlogListQuery,
} from "../../services/blog/blogApiSlice";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { BlogsTablePage } from "./blogsTable/BlogsTablePage";

export const BlogsListPage = () => {
  const { status, search } = useSelector(selectBlogFilter);

  const { isLoading, isSuccess } = useGetBlogListQuery({
    search,
    status,
  });
  const blogList = useSelector(selectAllBlogs);

  return isSuccess ? (
    <div className={classes.box}>
      <BlogsFilterPage />
      <BlogsTablePage data={blogList} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
